export default "__VITE_ASSET__C1Q5xwwH__"